var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-intro-step',{key:Date.now(),attrs:{"config":_vm.config},on:{"close":_vm.closeIntro},model:{value:(_vm.showa),callback:function ($$v) {_vm.showa=$$v},expression:"showa"}})
}
var staticRenderFns = []

export { render, staticRenderFns }